"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_native_1 = require("react-native");
var native_1 = __importDefault(require("styled-components/native"));
var injectStyleProp_1 = require("../utils/injectStyleProp");
var DefaultAtomValues_1 = require("../constants/DefaultAtomValues");
var LikeOnDoubleTap_1 = require("../components/LikeOnDoubleTap");
var defaultProps = {
    imageHeight: 300,
    imageWidth: 300,
    indicatorColor: DefaultAtomValues_1.DefaultAtomColors.gray,
    hideIndicator: false
};
// STYLED COMPONENTS ---------------------------------------------------------------------------------------------------
var HollowIndicator = native_1.default(react_native_1.View)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin: 0 4px;\n  height: 8px;\n  width: 8px;\n  border-radius: 4px;\n  border-width: 1px;\n  border-color: ", ";\n"], ["\n  margin: 0 4px;\n  height: 8px;\n  width: 8px;\n  border-radius: 4px;\n  border-width: 1px;\n  border-color: ", ";\n"])), function (props) { return props.indicatorColor || defaultProps.indicatorColor; });
var FilledIndicator = native_1.default(HollowIndicator)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  background-color: ", ";\n"], ["\n  background-color: ", ";\n"])), function (props) { return props.indicatorColor || defaultProps.indicatorColor; });
var IndicatorWrapper = native_1.default(react_native_1.View)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  margin: 16px 0 0 0; \n  flex-direction: row;\n"], ["\n  margin: 16px 0 0 0; \n  flex-direction: row;\n"])));
var CarouselWrapper = native_1.default(react_native_1.View)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  align-items: center;\n"], ["\n  align-items: center;\n"])));
var StyledImage = native_1.default(react_native_1.Image)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  ", ";\n  ", ";\n"], ["\n  ", ";\n  ", ";\n"
    // COMPONENT -----------------------------------------------------------------------------------------------------------
])), injectStyleProp_1.injectStyleProp('height'), injectStyleProp_1.injectStyleProp('width'));
// COMPONENT -----------------------------------------------------------------------------------------------------------
exports.ATLAtomCarousel = function (_a) {
    var imagesList = _a.imagesList, onDoubleTap = _a.onDoubleTap, imageHeight = _a.imageHeight, imageWidth = _a.imageWidth, indicatorColor = _a.indicatorColor, hideIndicator = _a.hideIndicator;
    var _b = react_1.useState(0), imageIndex = _b[0], setImageIndex = _b[1];
    // Renders the page indicator marks bellow the images
    var renderIndicator = function () { return (imagesList && imagesList.map(function (element, index) {
        if (index === imageIndex)
            return (react_1.default.createElement(FilledIndicator, { key: index, indicatorColor: indicatorColor }));
        else
            return (react_1.default.createElement(HollowIndicator, { key: index, indicatorColor: indicatorColor }));
    })); };
    // Renders one item of the carousel
    var renderImageItem = function (image) { return (react_1.default.createElement(StyledImage, { source: image, height: imageHeight, width: imageWidth, resizeMode: 'cover' })); };
    // Function passed to flat list
    var renderItem = function (_a) {
        var item = _a.item;
        if (onDoubleTap) {
            return (react_1.default.createElement(LikeOnDoubleTap_1.LikeOnDoubleTap, { key: item.id, viewHeight: imageHeight, viewWidth: imageWidth, onDoubleTap: onDoubleTap }, renderImageItem(item.image)));
        }
        else {
            return (renderImageItem(item.image));
        }
    };
    // Recognizes when image has changed and updates value watched by the image indicator
    var changeImageIndicator = react_1.useCallback(function (args) {
        setImageIndex(args.changed[0].index);
    }, []);
    // Returns complete ATLAtomCarousel
    return (react_1.default.createElement(CarouselWrapper, null,
        react_1.default.createElement(react_native_1.FlatList, { keyExtractor: function (item, index) { return index.toString(); }, data: imagesList || [], renderItem: renderItem, horizontal: true, showsHorizontalScrollIndicator: false, pagingEnabled: true, onViewableItemsChanged: changeImageIndicator, viewabilityConfig: { itemVisiblePercentThreshold: 100 } }),
        !hideIndicator && imagesList && imagesList.length > 1 &&
            react_1.default.createElement(IndicatorWrapper, null, renderIndicator())));
};
exports.ATLAtomCarousel.defaultProps = defaultProps;
exports.ATLAtomCarousel.displayName = 'ATLAtomCarousel';
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
